import { network } from 'services/network';

import { QueryParams } from 'api/mutations/UpdateRiskProperty.mutation';

export const updateRiskProperty = (params: QueryParams) => {
    return network.post('api/bo/updateRiskProperty', params).then((response) => {
        return response.data;
    });
};
